module.exports = __webpack_public_path__ + "static/media/map-pin.09100281.svg";